import { filter, Observable, map } from "rxjs";

export abstract class AStorageService {

  protected readonly abstract _internalObserver: Observable<StorageEvent>;
  protected readonly abstract _storage: Storage;

  public get<T>(key: string): T {
    const item = this._storage.getItem(key);
    if (!item) return null;
    try {
      return JSON.parse(item);
    }
    catch {
      return null;
    }
  }

  public set<T = unknown>(key: string, value: T): void {
    return this._storage.setItem(key, JSON.stringify(value))
  }

  public remove(key: string): void {
    return this._storage.removeItem(key);
  }

  public clear(): void {
    this._storage.clear();
  }

  public observe<T>(key: string): Observable<T> {
    return this._internalObserver.pipe(
      filter((e: StorageEvent) => (e.storageArea == this._storage && e.key == key)),
      map(() => this.get(key))
    )
  }
}
